import ReactDOM from 'react-dom';
import App from 'src/App';
import { AppShell } from 'src/AppShell';

// Clear console on vite hot reload
// https://github.com/vitejs/vite/discussions/3143
if (import.meta.hot) {
	import.meta.hot.on(
		'vite:beforeUpdate',
		() => console.clear(),
	);
}

const rootElement = document.querySelector('#root');
const application = (
	<AppShell>
		<App />
	</AppShell>
);

ReactDOM.render(application, rootElement);
